
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comparisons/frame-io-free-plan-limits",
      function () {
        return require("private-next-pages/comparisons/frame-io-free-plan-limits.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comparisons/frame-io-free-plan-limits"])
      });
    }
  